export const branchFeedbackFormIndex = {
	ifsokaktunus: 'https://ifsokak.com/qr/menu/?page_id=5845',
	ifsokaktepe: 'https://ifsokak.com/qr/menu/?page_id=7307',
	ifsokakcayyolu: 'https://ifsokak.com/qr/menu/?page_id=6818',
	ifsokaksogutozu: 'https://if.olabenja.com/iletisim',
	ifsokakeryaman: 'https://forms.gle/K7Ba3XtE8Q7ygz2i6',
};

export default branchFeedbackFormIndex;
